import * as types from "./types";
const defaultState = {
  selected_collection: undefined
};

const home_ui = (state = defaultState, action) => {
  switch (action.type) {
    case types.UPDATE_SELECTED_COLLECTION:
      return {
        ...state,
        selected_collection: action.collection
      };
    default:
      return state;
  }
};

export default home_ui;
